import Vue from "vue";
import Vuetify from "vuetify/lib";
import { icons } from "../icons";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg",
    values: {
      ...icons, // Map all our custom icons
      // Map Vuetify internal names to our icons
      dropdown: icons.dropdown,
      sort: icons.sort,
      checkboxOn: icons.checkboxOn,
      checkboxOff: icons.checkboxOff,
      checkboxIndeterminate: icons.checkboxIndeterminate,
      radioOn: icons.radioOn,
      radioOff: icons.radioOff,
      expand: icons.expand,
      menu: icons.menu,
      subgroup: icons.subgroup,
      edit: icons.edit,
      ratingEmpty: icons.ratingEmpty,
      ratingFull: icons.ratingFull,
      ratingHalf: icons.ratingHalf,
      loading: icons.loading,
      first: icons.first,
      last: icons.last,
      unfold: icons.unfold,
      file: icons.file,
      plus: icons.plus,
      minus: icons.minus,
      clear: icons.clear,
      close: icons.close,
      delete: icons.delete,
      prev: icons.prev,
      next: icons.next,
      delimiter: icons.delimiter // Carousel delimiter usually circle/box
    }
  },
  theme: {
    disable: true
  }
});
